export default __webpack_public_path__ + "static/media/Facebook.6386f062.svg";